module.exports = __webpack_public_path__ + "static/media/Illus-Delivery_1@3x.8bd56f47.png";